import React, { useState } from 'react';
import { useCRM } from '../context/CRMContext';
import { X } from 'lucide-react';

const LeadModal = ({ onClose, editData }) => {
  const { addPolicy, editPolicy, policyTypes = [] } = useCRM();
  
  const [formData, setFormData] = useState(editData ? {
    clientName: editData.clientName || '',
    phone: editData.phone || '',
    email: editData.email || editData.contact_email || '',
    type: editData.type || (policyTypes[0]?.name || 'Auto'),
    value: editData.value || '',
    value_uf: editData.value_uf || ''
  } : {
    clientName: '',
    phone: '',
    email: '',
    type: policyTypes[0]?.name || 'Auto',
    value: '',
    value_uf: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.clientName || !formData.phone) return;
    
    // Add prefix to value if it's just a number
    let finalValue = formData.value;
    if (finalValue && !finalValue.startsWith('$')) {
      finalValue = `$${finalValue}/año`;
    }

    if (editData?.id) {
      // Modo Edición
      editPolicy(editData.id, {
        clientName: formData.clientName,
        phone: formData.phone,
        email: formData.email,
        type: formData.type,
        value: finalValue,
        value_uf: formData.value_uf ? parseFloat(formData.value_uf.toString().replace(',', '.')) : null
      });
    } else {
      // Modo Creación
      addPolicy({
        ...formData,
        value: finalValue || '$ -',
        value_uf: formData.value_uf ? parseFloat(formData.value_uf.toString().replace(',', '.')) : null
      });
    }
    
    onClose();
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999,
      display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <div className="card animate-fade-in" style={{ width: '100%', maxWidth: '450px', position: 'relative' }}>
        <button 
          onClick={onClose}
          style={{ position: 'absolute', top: '1rem', right: '1rem', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-muted)' }}>
          <X size={20} />
        </button>
        
        <h2 style={{ marginBottom: '1.5rem' }}>{editData ? 'Editar Registro' : 'Añadir Nuevo Lead'}</h2>
        
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <div>
            <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: 500, marginBottom: '0.5rem' }}>Nombre Completo *</label>
            <input 
              required
              name="clientName"
              value={formData.clientName}
              onChange={handleChange}
              style={{ width: '100%', padding: '0.75rem', borderRadius: '4px', border: '1px solid var(--border)' }} 
              placeholder="Ej. Juan Pérez"
            />
          </div>
          
          <div style={{ display: 'flex', gap: '1rem' }}>
            <div style={{ flex: 1 }}>
              <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: 500, marginBottom: '0.5rem' }}>Teléfono *</label>
              <input 
                required
                name="phone"
                type="tel"
                value={formData.phone}
                onChange={handleChange}
                style={{ width: '100%', padding: '0.75rem', borderRadius: '4px', border: '1px solid var(--border)' }} 
                placeholder="+56 9 1234 5678"
              />
            </div>
            
            <div style={{ flex: 1 }}>
              <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: 500, marginBottom: '0.5rem' }}>E-mail de Contacto</label>
              <input 
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                style={{ width: '100%', padding: '0.75rem', borderRadius: '4px', border: '1px solid var(--border)' }} 
                placeholder="cliente@empresa.cl"
              />
            </div>
          </div>

          <div style={{ display: 'flex', gap: '1rem' }}>
            <div style={{ flex: 1 }}>
              <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: 500, marginBottom: '0.5rem' }}>Tipo de Seguro</label>
              <select 
                name="type"
                value={formData.type}
                onChange={handleChange}
                style={{ width: '100%', padding: '0.75rem', borderRadius: '4px', border: '1px solid var(--border)', backgroundColor: 'white' }}
              >
                {policyTypes.length > 0 ? (
                  policyTypes.map(pt => (
                    <option key={pt.id} value={pt.name}>{pt.name}</option>
                  ))
                ) : (
                  <option value="Auto">Cargando Seguros...</option>
                )}
              </select>
            </div>
            
            <div style={{ flex: 1 }}>
              <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: 500, marginBottom: '0.5rem' }}>Prima Estimada (CLP)</label>
              <input 
                name="value"
                value={formData.value}
                onChange={handleChange}
                style={{ width: '100%', padding: '0.75rem', borderRadius: '4px', border: '1px solid var(--border)', marginBottom: '1rem' }} 
                placeholder="Ej. 1.250.000"
              />
              
              <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: 500, marginBottom: '0.5rem', color: 'var(--text-main)' }}>Equivalente UF (Opcional)</label>
              <input 
                name="value_uf"
                value={formData.value_uf}
                onChange={handleChange}
                type="number"
                step="0.01"
                style={{ width: '100%', padding: '0.75rem', borderRadius: '4px', border: '1px solid var(--border)' }} 
                placeholder="Ej. 12.5"
              />
            </div>
          </div>

          <div style={{ marginTop: '1rem', display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
            <button type="button" className="btn" onClick={onClose}>Cancelar</button>
            <button type="submit" className="btn btn-primary">{editData ? 'Guardar Cambios' : 'Crear Prospecto'}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LeadModal;
